const Constants = Object.freeze({
  MESSAGE: {
    NOT_SUPPORTED: 'Not supported.',
    NO_CONTENT: 'No input content.',
    STARTED: 'Processing started.',
    COMPLETED: 'Processing completed.',
    TIMEOUT: 'Processing is taking longer than expected. Please be patient.',
  },
  POST: {
    TYPE: 'lh-mol-viewer',
    COMPLETE: 'complete',
    ERROR: 'error',
    START: 'processing_started',
    IMAGE_DATA: 'image_data',
  },
  ACTION: {
    EXPORT_IMAGE: 'exportImage',
  },
  EVENT: {
    MESSAGE: 'message',
    FAILURE: 'failure',
  },
  IFRAME: {
    ELEMENT_ID: 'iframe_jsmol',
  },
  TIMEOUT_MS: 30000,
  PROCESSING_TIMEOUT_MS: 30000,
});

export default Constants;
